<template>
  <div class="documents-event-modal-catalog-preview">
    <div class="item">
      <div class="item__info item__info--order">
        <span
          v-html="$t('event.catalog.modal.preview.documents.infoOrder')"
        ></span>
        <div class="item__warning">
          <icon name="warning" class="item__warning-icon" />
          <div class="item__warning-message">
            {{ $t("event.catalog.modal.preview.documents.requiredField") }}
          </div>
        </div>
      </div>

      <div class="item__links">
        <EventModalCatalogUploadFile
          v-if="status === 'draft'"
          :accepted-files="'.pdf, .PDF'"
          :accepted-files-info="'PDF'"
          :max-filesize="10"
          :init-file="files && files.orderFile ? files.orderFile : null"
          @upload-handler="updateFileOrder"
        />

        <a
          v-if="files.orderFile"
          href="#"
          class="item__download-link"
          download
          @click="downloadedOrderFile($event)"
        >
          <icon name="blank-doc-transparent" />
          <span>
            {{ $t("event.catalog.modal.preview.documents.downloadFile") }}

            <small v-if="paramsFileOrder">
              {{ paramsFileOrder }}
            </small>
          </span>
        </a>
      </div>
    </div>

    <div class="item">
      <div
        class="item__info"
        v-html="$t('event.catalog.modal.preview.documents.infoRequisites')"
      />

      <div class="item__links">
        <EventModalCatalogUploadFile
          v-if="status === 'draft'"
          :accepted-files="'.doc, .DOC, .docx, .DOCX'"
          :accepted-files-info="'DOCX'"
          :max-filesize="10"
          :init-file="
            files && files.requisitesFile ? files.requisitesFile : null
          "
          @upload-handler="updateFileRequisites"
        />

        <a
          v-if="files.requisitesFile"
          href="#"
          class="item__download-link"
          @click="downloadedRequisitesFile($event)"
        >
          <icon name="blank-doc-transparent" />
          <span>
            {{ $t("event.catalog.modal.preview.documents.downloadFile") }}

            <small v-if="paramsFileRequisites">
              {{ paramsFileRequisites }}
            </small>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventModalCatalogUploadFile from "@/components/Modal/Catalog/EventModalCatalogUploadFile.vue";
import apiCatalog from "@/api/catalog";

export default {
  name: "EventModalCatalogPreviewDocuments",

  components: { EventModalCatalogUploadFile },

  computed: {
    ...mapState("event", ["event"]),
    ...mapState("eventCatalog", ["files", "status"]),

    paramsFileOrder() {
      if (this.files.orderFile) {
        return `${this.files.orderFile.extension}, ${(
          +this.files.orderFile.size / 1024
        ).toFixed(2)} Кб`;
      }

      return null;
    },

    paramsFileRequisites() {
      if (this.files.requisitesFile) {
        return `${this.files.requisitesFile.extension}, ${(
          +this.files.requisitesFile.size / 1024
        ).toFixed(2)} Кб`;
      }

      return null;
    }
  },

  methods: {
    updateFileOrder(file) {
      this.$store.dispatch("eventCatalog/setFileOrder", {
        eventId: this.event.id,
        orderId: this.event.catalog_order_id,
        file
      });
    },

    updateFileRequisites(file) {
      this.$store.dispatch("eventCatalog/setFileRequisites", {
        eventId: this.event.id,
        orderId: this.event.catalog_order_id,
        file
      });
    },

    downloadedOrderFile(e) {
      e.preventDefault();
      this.downloadedFile("confirmation");
    },

    downloadedRequisitesFile(e) {
      e.preventDefault();
      this.downloadedFile("requisites");
    },

    async downloadedFile(type) {
      const response = await apiCatalog.downloadFile(
        this.event.id,
        this.event.catalog_order_id,
        type
      );
      let blob = new Blob([response], {
        type: "application/pdf"
      });
      const url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = url;
      link.download =
        type === "confirmation"
          ? this.files.orderFile.original_name
          : this.files.requisitesFile.original_name;
      link.click();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.documents-event-modal-catalog-preview {
  margin-bottom: 46px;
  padding: 20px 0 55px;
  border-bottom: 1px solid #e7e7e7;

  * {
    box-sizing: border-box;
  }
  .event-modal-catalog-preview__warning ~ & {
    padding-top: 50px;
    border-top: 1px solid #e7e7e7;
  }
  .item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: flex-start;
    align-items: center;
    margin-bottom: 22px;

    @include respond-down(md) {
      display: block;
    }
    &:last-child {
      margin-bottom: 0;
    }
    &__info {
      display: inline-block;
      vertical-align: middle;
      padding: 10px 20px;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      color: #262626;
      background-color: #f1f1f1;

      &--order {
        position: relative;
        max-width: 405px;

        @include respond-down(md) {
          max-width: 100%;
        }
      }
    }
    &__links {
      display: flex;
      flex-direction: row-reverse;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-content: flex-start;
      align-items: flex-start;
      min-width: 280px;
      margin-left: 50px;

      @include respond-down(lg) {
        min-width: 250px;
      }
      @include respond-down(md) {
        margin-top: 15px;
        margin-left: 0;
        min-width: auto;
        width: 270px;
        max-width: 100%;
        flex-direction: row;
      }
    }
    &__download-link {
      display: flex;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      color: #009ee3;

      text-decoration: none;
      user-select: none;
      cursor: pointer;

      .svg-icon {
        width: 16px;
        height: 16px;
        margin-right: 9px;
      }
      small {
        display: block;
        margin-top: 2px;
        margin-left: 1px;
        font-weight: 400;
        font-size: 12px;
        line-height: 1.5;
        color: #a3a8b3;
      }
    }
    &__warning {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-end;
      position: absolute;
      right: -6px;
      top: -6px;
      width: 100%;
      line-height: 1;

      &-icon {
        width: 16px;
        height: 16px;
        cursor: pointer;

        &:hover ~ .item__warning-message {
          display: block;
        }
      }
      &-message {
        display: none;
        position: absolute;
        top: calc(100% + 13px);
        right: -20px;
        padding: 8px 13px 7px 12px;
        font-size: 12px;
        line-height: 16px;
        border: 1px solid #d8d8d8;
        border-radius: 2px;
        color: #6d7179;
        background-color: #ffffff;

        @include respond-down(md) {
          right: -10px;
        }
        &:after {
          content: "";
          display: block;
          position: absolute;
          top: -7px;
          right: 20px;
          width: 12px;
          height: 12px;
          border-top: 1px solid #d8d8d8;
          border-right: 1px solid #d8d8d8;
          border-radius: 2px;
          background-color: #ffffff;
          transform: rotate(-45deg);

          @include respond-down(md) {
            right: 10px;
          }
        }
      }
    }
  }
}
</style>
